<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bwjhTE/tc-custom/9781429905442.jpg?1731159883365" alt="This image is the cover for the book Keeper's Son, Josh Thurlow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Keeper's Son, Josh Thurlow
      </h1>
      <p class="bookDescription body article font2">
        <b>A Coast Guard commander faces Nazi aggression in American waters in this “beautifully written and nerve-wrackingly suspenseful” novel of WWII (Nelson DeMille).</b><br/><br/><i>North Carolina, 1941</i>. Among the wind-swept Outer Banks, Killakeet Island is home to a peaceful community of fishermen, clam stompers, oyster rakers, and a few lonely Coast Guard sailors. Dominating the tiny island landscape is the majestic Killakeet Lighthouse, which has been overseen by the Thurlow family for generations. But now Josh Thurlow, the Keeper’s son, has chosen another path . . .<br/><br/>Seventeen years ago, Josh lost his younger brother at sea. Still wracked with guilt, he searches relentlessly for him as commander of a Coast Guard patrol boat. But Josh’s obsession with the past is complicated by the arrival of a beautiful stranger—and a foreign enemy. In Killakeet to escape the outside world, Dosie Crossan has stirred Josh’s heart. Meanwhile, a wolfpack of German U-boats has arrived to soak the island’s beaches with blood and oil.<br/><br/>One of the U-boats is captained by the infamous Nazi warrior Otto Krebs. But Krebs has brought more than torpedoes to Killakeet. He may also have the answer to the mystery that haunts Josh Thurlow.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Homer Hickam
      </h2>
      
      <p class="authorDescription body article"><P><B>Homer Hickam</B> is the author of six previous books, most notably the #1 <I>New York Times</I> bestseller <I>Rocket Boys</I>, which was made into the acclaimed movie <I>October Sky</I>. He is a Vietnam veteran, a scuba instructor, a retired rocket scientist, and an amateur paleontologist. More than anything else, he loves to write. He and his wife, Linda, and their cats divide their time between homes in the Virgin Islands and Huntsville, Alabama.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f709ca4